<div class="request-details-container">
  <div class="container-fluid">
    <div class="row g-6 mb-6"></div>
    <div class="table-container">
      <div
        class="parking-request-title d-flex justify-content-between align-items-center"
      >
        <h5>Detalii cerere</h5>
        <div
          class="text-end"
          *ngIf="
            userRequestDetailsData.status === 'pending' ||
            userRequestDetailsData.status === 'userActionNeeded'
          "
        >
          <button
            type="button"
            *ngIf="userRequestDetailsData.status === 'userActionNeeded'"
            (click)="sendNotification()"
            class="btn btn-sm btn-neutral btn-notify-user"
          >
            Notifică
          </button>
          <button
            [disabled]="!isAcceptButtonEnabled()"
            (click)="acceptRequest('accepted', '')"
            type="button"
            class="btn btn-sm btn-neutral btn-accept-enabled"
          >
            <i class="bi bi-check"></i>
            Acceptă
          </button>
          <button
            (click)="openDialog(requestId)"
            type="button"
            class="btn btn-sm btn-neutral btn-decline-big"
          >
            <i class="bi bi-x"></i>Respinge
          </button>
        </div>
      </div>

      <div class="table-containers-bottom">
        <div class="container-left">
          <div class="parking-request-details">
            <div class="user-info">
              <p>Nume:</p>
              <span>{{
                userRequestDetailsData?.requester?.firstName || "-"
              }}</span>
            </div>
            <div class="user-info">
              <p>Prenume:</p>
              <span>{{
                userRequestDetailsData?.requester?.lastName || "-"
              }}</span>
            </div>
            <div class="user-info">
              <p>CNP:</p>
              <span>{{ userRequestDetailsData?.requester?.ssn || "-" }}</span>
            </div>
            <div class="user-info">
              <p>E-mail:</p>
              <span>{{ userRequestDetailsData?.requester?.email || "-" }}</span>
            </div>
            <div class="user-info">
              <p>Telefon:</p>
              <span>{{
                userRequestDetailsData?.requester?.phoneNumber || "-"
              }}</span>
            </div>
            <div class="user-info">
              <p>Număr de înmatriculare:</p>
              <span>{{ userRequestDetailsData?.licensePlate || "-" }}</span>
            </div>
            <div class="user-info">
              <p>Adresă:</p>
              <span>{{
                userRequestDetailsData?.requester?.address || "-"
              }}</span>
            </div>
            <hr />
            <div class="user-info">
              <p>Tip cerere:</p>
              <span>{{
                getRequestNameByType(userRequestDetailsData.type) || "-"
              }}</span>
            </div>
            <div class="user-info">
              <p>Abonament</p>
              <span>{{
                userRequestDetailsData?.subscriptionZone?.zoneName
              }}</span>
            </div>
            <div class="user-info info-bottom">
              <p>Data cererii:</p>
              <span>{{
                userRequestDetailsData?.createdAt
                  | date : "dd-MM-yyyy, HH:mm:ss" || "-"
              }}</span>
            </div>
            <div class="user-info">
              <p>Status:</p>
              <span>{{
                getStatusNameByType(userRequestDetailsData.status) || "-"
              }}</span>
            </div>
            <div class="user-info">
              <p>Motivul respingerii:</p>
              <span>{{ userRequestDetailsData.rejectionReason || "-" }}</span>
            </div>
          </div>
        </div>
        <div class="container-right">
          <div class="user-documents">
            <p>Documente:</p>
            <ol>
              <li *ngIf="documentData.length === 0" class="document-item">
                <div class="document-content">-</div>
              </li>
              <li
                *ngFor="let document of documentData; let i = index"
                class="document-item"
              >
                <div class="action-container">
                  <div class="document-info">
                    <p>
                      {{ i + 1 }}. {{ getDocumentNameByType(document.type) }}
                    </p>
                  </div>
                  <div
                    class="action-div"
                    *ngIf="
                      userRequestDetailsData.status === 'pending' ||
                      userRequestDetailsData.status === 'userActionNeeded'
                    "
                  >
                    <button
                      (click)="
                        selectedDocumentIndex = i; acceptDocument(document)
                      "
                      class="btn btn-sm btn-neutral btn-accept"
                      [class.accepted]="document.status === 'accepted'"
                    >
                      <i class="bi bi-check bi-smaller"></i>
                    </button>
                    <button
                      (click)="
                        selectedDocumentIndex = i; declineDocument(document)
                      "
                      class="btn btn-sm btn-neutral btn-decline"
                      [class.declined]="document.status === 'rejected'"
                    >
                      <i class="bi bi-x bi-smaller"></i>
                    </button>
                  </div>
                </div>
                <div class="document-content">
                  Document
                  <a href="{{ document?.resourceUrl }}" target="_blank">
                    {{ getDocumentNameByType(document.type) }}
                  </a>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
